import { RollbackOutlined } from '@ant-design/icons';

import { useModal } from 'hooks/useModal';
import { Document } from 'interfaces/documents';
import { MenuItemType } from 'antd/es/menu/interface';

export const Versions = (row: Document): MenuItemType => {
    const { openModal } = useModal();

    return {
        key: 'Versions',
        label: 'Versions',
        onClick: () => {
            openModal('documentVersionsModal', {
                document: row,
            });
        },
        icon: <RollbackOutlined />,
    };
};